<template>
  <div id="app">
					<div class="text">
            <div class="container">
            <div class="row">
              <div class="col-md-3" style="text-align:left;">
 <b><label>Dátum od:</label></b>
<!--<datepicker v-model="dateFrom" :format="'dd/MM/yyyy'" @selected="dateChange"></datepicker>-->
<datetime type="date" v-model="dateFrom"></datetime>
</div>

<div class="col-md-3" style="text-align:left;">
  <b><label>Dátum do</label></b>
<!--<datepicker v-model="dateTo" :format="'dd/MM/yyyy'"></datepicker>-->
<datetime type="date" v-model="dateTo"></datetime>

  </div>

<div class="col-md-2" style="text-align:left;">
  <b><label>Užívateľ</label></b>
<select class="form-control" id="sel1" v-model="user">
    <option v-for="(user, index) in users" :key="index" :value="user.email">{{user.firstname}} {{user.lastname}}</option>
  </select>  
  </div>
  

  <div class="col-md-1" style="text-align:left;margin-top:30px;">
						<button type="button" href="#" class="txt2 hov1 btn btn-primary" @click="load">
							Načítaj
						</button>
          </div>


</div>
<hr>
<div class="container">
  <h2>Výsledky</h2>            
  <table class="table table-striped" style="text-align:left">
    <thead style="text-align:left">
      <tr style="text-align:left">
        <th style="text-align:left">Dátum</th>
        <th>Projekt + čas bez prestávok</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(day, index) in this.range" :key="index" :style="day.projects.length == 0 ? { 'background-color': 'orange'} : ''">
        <td>{{day.date | moment("DD/MM/YYYY")}}</td>
        <td v-if="day.projects.length > 0">
            <ul>
              <li v-for="(p, index) in day.projects" :key="index">{{p.project}} - <b>Odpracované:</b> {{p.seconds}} (od {{ new Date(p.begin * 1000) | moment('HH:mm:ss')}} do {{ new Date(p.end * 1000) | moment('HH:mm:ss')}})| <b>Prestávky:</b> {{p.totalBreakHours}} | <b>Najazdené: {{p.totalKm}} km</b></li>
            </ul>

        </td>
        <td v-else><i>Voľno</i></td>
      </tr>
    </tbody>
  </table>
<hr>
<p><b>Spolu odpracované:</b> {{secondsToHms(totalSeconds)}}</p>
<p><b>Spolu prestávky:</b> {{secondsToHms(totalBreaksSeconds)}}</p>
<p><b>Spolu najazdených:</b> {{totalKm}} kilometrov</p>
</div>


</div>
					</div>
  </div>
</template>

<script>
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'
import firebase from 'firebase'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import navbar from './components/Navbar.vue'
import Vue from 'vue'

export default {
  components : {
    Datepicker
  },
  name: 'Tracker',
  data() {
    return {
      project : "",
      projects : [],
      totalBreaksSeconds : 0,
      users : [],
      dateFrom : '',
      dateTo : '',
      user : '',
      result : [],
      totalSeconds : 0,
      totalHours : "",
      totalKm : 0,
      range : []
    }
  },
  methods : {
        secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hodina, " : " hodín, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minúta, " : " minút, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sekunda" : " sekúnd") : "";
    return hDisplay + mDisplay + sDisplay; 
},

    async getProjects()
    {
            await firebase.firestore().collection('project').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.projects = snap.docs.map(x => x.data());
        }
        });
    },
    async getUsers()
    {
            await firebase.firestore().collection('user').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.users = snap.docs.map(x => x.data());
        }
        });
    },    
    dateChange()
    {
      console.log("wat");
      console.log(this.dateFrom);
    },
    getDates(startDate, stopDate) {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= stopDate) {
        dateArray.push(new Date (currentDate));
        currentDate = currentDate.addDays(1);
    }
    return dateArray;
},
    async load()
    {
      this.range = [];
      console.log("from " + this.dateFrom);
      console.log("to " + this.dateTo);
      this.totalSeconds = 0;
      this.totalBreaksSeconds = 0;
      this.totalHours = "";
      this.totalKm = 0;

      let startDate = new Date(this.dateFrom);
      
      startDate = moment(startDate);
      startDate.set({m:0,m:0,s:0});

      console.log("startdate is " + startDate.toDate());

      let endDate = new Date(this.dateTo);
      endDate = moment(endDate);
      endDate.set({h:23,m:59,s:59});


      let dateArray = [];

      while(startDate <= endDate)
      {
        dateArray.push(startDate);
        startDate = moment(startDate).add(1, 'days');
      }

      dateArray.forEach(d => {

        let day = {
          date: moment(d),
          projects : []
        };
      let endDate = moment(d);
      endDate.set({h: 23, m: 59, s: 59});

      console.log("user is "+ this.user);

        firebase.firestore().collection('timer').where('email', '==', this.user).
        where('begin', '>', day.date.toDate()).where('begin', '<', endDate.toDate()).get().then(async data => {

              data.docs.forEach(p => {
                
              if(p.data().begin != null & p.data().end != null)
              {
                let seconds = p.data().end.seconds - p.data().begin.seconds;
                this.totalSeconds += seconds;

                if(p.data().end_km > 0 && p.data().start_km > 0)
                {
                  this.totalKm += p.data().end_km - p.data().start_km;
                }
                
                var breaks = Math.floor(seconds / 21600);
                
                
                if(breaks > 0)
                {                    
                     this.totalSeconds -=  (1800 * breaks);
                     this.totalBreaksSeconds += (1800 * breaks);
                }

                Object.assign(p.data(), {'seconds' : seconds});

                let newRecord = {
                  type : p.data().type,
                  project : p.data().project,
                  end : p.data().end,
                  begin : p.data().begin,
                  start_km : p.data().start_km,
                  end_km : p.data().end_km,
                  totalKm : p.data().end_km - p.data().start_km,
                  seconds : this.secondsToHms(seconds),
                  totalBreakHours : this.secondsToHms(breaks * 1800)
                };

                day.projects.push(newRecord);
                
              }
            });

        });
        this.range.push(day);

      });


    }
  },
  created()
  {

    
    this.getUsers();
    this.getProjects();
    
    console.log("tracker!");

    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
